'use strict';

customerZone

/**
 * A banner that appears if the current user is impersonating
 * @param user: user object having the functions 'name', 'impersonating' and 'logout'
 */
.component('impersonationBanner', {
    bindings: {
        user: '<'
    },
    templateUrl: customerZone.fromBase('components/impersonation-banner/impersonation-banner.component.html'),
    controllerAs: 'vm'
});
